import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import * as FlatModels from '@medsurf/flat-models';
import { MenuSharedFacade, SlideViewerFacade } from '@medsurf/flat-facades';
@Component({
    selector: 'medsurf-slide-header',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './slide-header.component.html',
    styleUrls: ['./slide-header.component.scss'],
    standalone: false
})
export class SlideHeaderComponent {

  @Input() public page: FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training;

  constructor(public slideViewerFacade: SlideViewerFacade,
              public menuSharedFacade: MenuSharedFacade
            ) {
  }

  public isDeepzoom(mediaType: FlatModels.MediaEntityModels.MediaType): boolean {
    return mediaType === FlatModels.MediaEntityModels.MediaType.enum.MediaDeepzoom;
  }

  public isImage(mediaType: FlatModels.MediaEntityModels.MediaType) {
    return mediaType === FlatModels.MediaEntityModels.MediaType.enum.MediaImage;
  }

  public setThemeColor(value: boolean, themeColor: string): string {
    return (value) ? themeColor : '';
  }
}
